export default __webpack_public_path__ + "static/media/bg1.a48f57b1.jpg";